import { css } from "@emotion/react";

export const container = css`
  height: 100%;
`;

export const margin = css`
  & > * {
    margin-bottom: 0.5rem;

    label:has(input[type="checkbox"]) {
      margin-left: 0.125rem;
    }
  }
`;
